import { Trans } from '@lingui/react/macro';
import { Alert } from '@warp-ds/react';
import type React from 'react';
import { MAX_IMAGES } from '../constants.js';

interface ImageAlertsProps {
  alert: null | 'UploadError' | 'InvalidFileType' | 'FileTooLarge' | 'RotateError' | 'TooManyImages';
}

export const ImageAlerts: React.FC<ImageAlertsProps> = ({ alert }) => {
  const maxImages = MAX_IMAGES;
  return (
    <>
      {alert === 'TooManyImages' && (
        <Alert type="negative" show className="mt-16">
          <Trans
            id="mobility-item-insertion.form.upload-images.too-many-alert"
            comment="Message letting the user know that they have reached the limit of images"
          >
            The total number of images cannot exceed {maxImages}.
          </Trans>
        </Alert>
      )}
      {alert === 'UploadError' && (
        <Alert type="negative" show className="mt-16">
          <Trans
            id="mobility-item-insertion.form.upload-images.failed-alert"
            comment="Message letting the user know that one or several images failed to upload"
          >
            One or more of your images failed to upload. Please try again.
          </Trans>
        </Alert>
      )}
      {alert === 'InvalidFileType' && (
        <Alert type="negative" show className="mt-16">
          <Trans
            id="mobility-item-insertion.form.upload-images.invalid-file-type-alert"
            comment="Message letting the user know that one or several images were of an incorrect file type"
          >
            One or more of your images were of incorrect type. We support uploading .jpg, .heic, .png, and .gif file
            types. Please try again.
          </Trans>
        </Alert>
      )}
      {alert === 'FileTooLarge' && (
        <Alert type="negative" show className="mt-16">
          <Trans
            id="mobility-item-insertion.form.upload-images.file-too-large-alert"
            comment="Message letting the user know that one or several images were too large to be uploaded"
          >
            One or more of your images were too large to be uploaded. The maximum file size is 20 MB.
          </Trans>
        </Alert>
      )}
      {alert === 'RotateError' && (
        <Alert type="negative" show className="mt-16">
          <Trans
            id="mobility-item-insertion.upload-image.rotate-failed-alert"
            comment="Alert message shown when image rotation fails"
          >
            Failed to rotate image. Please try again.
          </Trans>
        </Alert>
      )}
    </>
  );
};
